module.exports = __webpack_public_path__ + "img/regUsering.eaaf00a1.png";